import React from 'react';
import PropTypes from 'prop-types';
import {Table} from 'semantic-ui-react';

const LocalStorage = props => {

  const { globalParameters } = JSON.parse(localStorage.getItem(props.item) || "{}");
  if (!globalParameters || Object.keys(globalParameters).length === 0) {
    return <div>No data in persisted storage</div>;
  }
  return (
    <Table compact size='small'>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Key</Table.HeaderCell>
          <Table.HeaderCell>Value</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {Object.keys(globalParameters).map(key => {
          return (
            <Table.Row key={key}>
              <Table.Cell>{key}</Table.Cell>
              <Table.Cell>{globalParameters[key]}</Table.Cell>
            </Table.Row>
          );
        })}
      </Table.Body>
    </Table>
  );
};

LocalStorage.propTypes = {
  item: PropTypes.string.isRequired
};

export default LocalStorage;